import Button from "@mui/material/Button";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { useSelector, useDispatch } from "react-redux";
import { localizationService } from "services/localization-service";
import { loadAccount } from "../actions/account";
import { default as lynxColors } from "../modules/lynxColors";
import { completeTour } from "../services/accounts";
import { localStorageService } from "../services/local-storage-service";
import { TourTypes } from "../types/enums";
import { LynxDialog } from "./lynx-dialog";
export function LynxTour(props) {
  const dispatch = useDispatch();
  const [showIntro, setShowIntro] = React.useState(false);
  const [tourState, setTourState] = useState({
    run: false,
    steps: props.steps,
    stepIndex: 0,
  });

  const account = useSelector((state) => state.account);
  useEffect(() => {
    if (!account.isLoading) {
      const currentStep = localStorageService.getLocalStorage(props.flagField);
      if (account[props.flagField]) {
        return;
      }
      if (
        props.tourType != TourTypes.Initial &&
        !account.initialTourCompletedDateTimeUtc
      ) {
        return;
      }

      if (
        !account[props.flagField] &&
        (!currentStep || currentStep == 0) &&
        account.hasAcceptedTermsOfUse &&
        ((account.isBillingInApp && account.stringId) ||
          !account.isBillingInApp)
      ) {
        setShowIntro(true);
      } else {
        setTourState({
          ...tourState,
          run: true,
          stepIndex: _.toNumber(currentStep),
        });
      }
    }
  }, [account]);

  const { run, stepIndex, steps } = tourState;

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      const nextStep = index + (action === ACTIONS.PREV ? -1 : 1);
      localStorageService.setLocalStorage(
        props.flagField,
        _.toString(nextStep)
      );
      // Update state to advance the tour
      setTourState({
        ...tourState,
        stepIndex: nextStep,
      });
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      completeTour(props.tourType).then((res) => {
        dispatch(loadAccount());
      });
      localStorageService.removeLocalStorage(props.flagField);
      setTourState({ ...tourState, run: false });
    }
  };

  return (
    <>
      <LynxDialog
        open={showIntro}
        title={props.title}
        description={props.description}
        buttons={() => {
          return (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setShowIntro(false);
                setTourState({ ...tourState, run: true });
              }}
            >
              {localizationService.getLocalizedString("screen.tours.startTour")}
            </Button>
          );
        }}
      ></LynxDialog>

      <Joyride
        hideCloseButton
        callback={handleJoyrideCallback}
        run={run}
        stepIndex={stepIndex}
        continuous={true}
        steps={steps}
        locale={{
          back: localizationService.getLocalizedString(
            "screen.tours.buttons.back"
          ),
          close: localizationService.getLocalizedString(
            "screen.tours.buttons.close"
          ),
          last: localizationService.getLocalizedString(
            "screen.tours.buttons.last"
          ),
          next: localizationService.getLocalizedString(
            "screen.tours.buttons.next"
          ),
          open: localizationService.getLocalizedString(
            "screen.tours.buttons.open"
          ),
          skip: localizationService.getLocalizedString(
            "screen.tours.buttons.skip"
          ),
        }}
        styles={{
          options: {
            primaryColor: lynxColors.harvestOrange,
          },
        }}
      />
    </>
  );
}
